/**
 * Шапка меняет фон при скролле (класс .is--stuck).
 */
export function initStickyHeader() {
  const header = document.querySelector(".header");
  if (!header) return;

  const THRESHOLD = 20;
  const onScroll = () => {
    header.classList.toggle("is--stuck", window.scrollY > THRESHOLD);
  };

  window.addEventListener("scroll", onScroll, { passive: true });
  onScroll();
}
